import React from "react";
import { SECURE_FILE_SORT_COLUMNS } from "../../utils/secureFileList";

const SecureFileSortableHeader = ({ label, column, sortConfig, onSort }) => {
  const isActive = sortConfig.column === column;
  const sortIndicator = !isActive ? "↕" : sortConfig.direction === "asc" ? "↑" : "↓";

  return (
    <th aria-sort={isActive ? (sortConfig.direction === "asc" ? "ascending" : "descending") : "none"}>
      <button
        type="button"
        className={`secure-file-sort-button ${isActive ? "is-active" : ""}`}
        onClick={() => onSort(column)}
        aria-label={`Sort by ${label}`}
      >
        <span>{label}</span>
        <span className="secure-file-sort-indicator" aria-hidden="true">
          {sortIndicator}
        </span>
      </button>
    </th>
  );
};

const SecureFileTableHead = ({ sortConfig, onSort }) => (
  <thead>
    <tr>
      <SecureFileSortableHeader
        label="File"
        column={SECURE_FILE_SORT_COLUMNS.FILE_NAME}
        sortConfig={sortConfig}
        onSort={onSort}
      />
      <SecureFileSortableHeader
        label="Uploaded By"
        column={SECURE_FILE_SORT_COLUMNS.UPLOADED_BY}
        sortConfig={sortConfig}
        onSort={onSort}
      />
      <SecureFileSortableHeader
        label="Uploaded At"
        column={SECURE_FILE_SORT_COLUMNS.UPLOADED_AT}
        sortConfig={sortConfig}
        onSort={onSort}
      />
      <th className="secure-file-static-header">Retains Until</th>
      <th className="secure-file-static-header">Size</th>
      <th className="secure-file-static-header">Share Link</th>
      <th className="secure-file-actions-column secure-file-static-header">Actions</th>
    </tr>
  </thead>
);

export default SecureFileTableHead;
